export default __webpack_public_path__ + "static/media/V450_RoHS.cc39990a.pdf";